














import {
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import {
  InvestmentCustodian,
  DrivewealthEnrollment,
  DrivewealthWizardStep } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import MixedInvestmentPage from "@/employee/components/investments/MixedInvestmentPage.vue";
import * as Routes from "@/employee/route-names";
import * as SharedRoutes from "@/shared/route-names";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    GenericLoadingSpinner,
    MixedInvestmentPage,
  }
})

export default class InvestmentAccount extends mixins(ErrorsMixin) {
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  featureFlagStore = useFeatureFlagStore();
  drivewealthStore = useDrivewealthStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  portalCustomizationStore = usePortalCustomizationStore();
  investmentThresholdStore = useInvestmentThresholdStore();
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop({ required: false, default: InvestmentCustodian.None }) displayedCustodian: InvestmentCustodian;

  @Prop({required: false, default: false})
  force: boolean;

  tryRedirectToCustodianComplete = false;
  mounted (): void {
    this.custodianSettingsStore.getCustodianSettings();
    this.investmentThresholdStore.loadInvestmentThresholds({});
    this.investmentDailyBalanceStore.loadCurrentDailyBalance();
    this.tryRedirectToCustodian();
  }

  get isLoading () {
    let isLoading = !this.investmentDailyBalanceStore.currentBalanceIsLoaded ||
      !this.investmentThresholdStore.thresholdsLoaded ||
      !this.investmentDailyBalanceStore.areBalancesByCustodianLoaded;

    if (this.featureFlagStore.flags.bend15911EnableDrivewealthMultiAccountViews
      && this.investmentThresholdStore.investmentProvider === InvestmentCustodian.Drivewealth) {
      isLoading = isLoading || !this.drivewealthStore.accountIdsLoaded;
    }

    if (!isLoading) {
      this.tryRedirectToCustodian();
    }
    return isLoading;
  }

  get shouldLandOnMixedInvestmentPage (): boolean {
    return this.custodianSettingsStore.isHsaBankCustodian;
  }

  tryRedirectToCustodian () {
    const locationName = this.investmentLandingLocation();
    if (!locationName) {
      this.tryRedirectToCustodianComplete = true;
      return;
    }

    if (locationName === SharedRoutes.DrivewealthInvestmentAccountV2) {
      const dwAccountId = this.drivewealthStore.accountIds[0];
      const query = this.force ? { force: "true" } : {  };
      this.$router.replace({
        name: locationName,
        params: { accountId: `${dwAccountId}` },
        query
      });
    } else {
      this.$router.replace({ name: locationName });
    }
  }

  investmentLandingLocation () {
    if (this.shouldLandOnMixedInvestmentPage) {
      return null;
    }
    const hasMultipleDrivewealthAccounts = this.drivewealthStore.accountIds.length > 1;
    switch (this.investmentThresholdStore.investmentProvider) {
      case InvestmentCustodian.Umb:
        return Routes.UmbInvestmentAccount;

      case InvestmentCustodian.Drivewealth:
        if (this.featureFlagStore.flags.bend15911EnableDrivewealthMultiAccountViews) {
          if (hasMultipleDrivewealthAccounts) {
            return Routes.DrivewealthMultipleAccountSelection;
          } else if (this.drivewealthStore.accountIds.length) {
            return SharedRoutes.DrivewealthInvestmentAccountV2;
          }
        }

        return SharedRoutes.DrivewealthInvestmentAccount;

      default:
        return null;
    }
  }

  @Watch("investmentLandingLocation")
  redirectAsNeeded () {
    this.tryRedirectToCustodian();
  }

}
